/* eslint-disable no-unused-vars */
export enum LocalStorageKey {
  RETAIL_CART = "retailCart",
  RESTAURANT_CART = "restaurantCart",
  SERVICE_CART = "serviceCart",
  SERVICE_CART_TIMESTAMP = "serviceCart_TIMESTAMP",
  TABLE_DATA = "tableData",
  DELIVERY_ADDRESS = "deliveryAddress",
  BOOKED_SERVICE_CART = "bookedServiceCart",
  SCAN_TO_ORDER_INFO = "scanToOrderInfo",
  GIFT_CARD = "giftCard",
  TEST_KEY = "testKey",
  COOKIE_BANNER_SEEN = "cookieBannerSeen",
  NEWCOLO_ONLOADPOP_ISTOUCHED = "newcolo_onloadpop_istouched",
  SCANTOORDER_WELCOME_MODAL_TOUCED = "scantoorder_welcome_modal_touched",
  CURRENT_CART_EVENT = "current-cart",
  RESTAURANT_CART_SYNC = "restaurant-cart",
  RETAIL_CART_SYNC = "retail-cart",
  DELIVERY_ORDER_TYPE = "delivery-order-type",
  PICKUP_ORDER_TYPE = "pickup-order-type",
  CMA_CONTINUE_AS_GUEST = "cma-continue-as-guest",
}

export enum SessionStorageKey {
  GIFT_CARD_INFO = "giftCardInfo",
  ORDER_ESTIMATES = "orderEstimates",
  SCHEDULED_TIME = "scheduledTime",
  RECEIPT_ID = "receiptId",
  PICKUP_TIME = "pickupTime",
  DELIVERY_TRACKING_URL = "deliveryTrackingUrl",
  CAN_ACCESS_CONFIRMATION = "canAccessConfirmation",
  ORDER_DETAILS = "orderDetails",
  TEST_KEY = "testKey",
  ONLOAD_SCHEDULEDORDER_POPUP_ISTOUCHED = "onload_scheduledOrderPopup_isTouched",
  DAYPART_MENU = "daypartMenu",
  LAST_FOCUSED_ITEM_ID = "lastFocusedItemId",
  REORDER_UNAVAILABLE_ITEMS = "reorderUnavailableItems",
  REORDER_ADDED_COUNT = "reorderAddedCount",
}
